/**
 * React hook for sorting crops within timeline groups
 */

import { useMemo } from 'react'
import { applySortingToGroups } from '../utils/crop-sorting-utils'

/**
 * Hook for applying sorting to grouped crops
 *
 * @param {Object} params
 * @param {Array} params.groups - Array of group objects from useCropScheduleGroups
 * @param {string} params.sortStrategy - 'none' | 'alphabetical' | 'chronological'
 * @returns {Array} Groups with sorted crops
 */
export const useCropScheduleSort = ({ groups, sortStrategy = 'none' }) => {
  const sortedGroups = useMemo(() => {
    return applySortingToGroups(groups, sortStrategy)
  }, [groups, sortStrategy])

  return sortedGroups
}
